const styles = {
  container: {
    margin: '50px auto 100px',
    maxWidth: '930px',
    paddingBottom: '50px',
    paddingTop: '45px'
  }
}

export default styles
